import * as React from "react";
import { DatePicker } from "../../../../../../../react-core/Datepicker/DatePicker";
import { PercentageTextBoxEditor } from "../../../../../../../react-core/Html/PercentageTextBoxEditor";
import { SelectEditor } from "../../../../../../../react-core/Html/SelectEditor";
import { addDays, addMonths } from "../../../../../../../react-core/utils/date";
import { IJsonDate, JsonDateParser } from "../../../../../../../react-core/Utils/JsonDateParser";
import { Indexation as IndexationEntity } from "../../../../../../../Wrap/Models/Models/Processes/Quote/Pension/Indexation";
import { IndexationEffectiveDateType } from "../../../../../../../Wrap/Models/Models/Processes/Quote/Pension/IndexationEffectiveDateType";
import { IndexationType } from "../../../../../../../Wrap/Models/Models/Processes/Quote/Pension/IndexationType";
import { ProcessComponent } from "../../../../../../Shared/Process/Process/ProcessComponent";
import { datePickerOptions } from "../../Resource/Contents";
interface IIndexationProps {
    firstPaymentDate: Date;
    data: IndexationEntity;
    onChange: (indexaton: IndexationEntity) => void;
    onRef: (ref) => void;
}

interface IIndexationState { }

export class Indexation extends ProcessComponent<IIndexationProps, IIndexationState> {
    constructor(props: any) {
        super(props);
        this.state = {};
    }

    public render(): JSX.Element {
        const { onChange, data } = this.props;

        const anniversarydate = this.props.firstPaymentDate ? JsonDateParser.toJsonDate(addMonths(JsonDateParser.toDate(this.props.firstPaymentDate), 12)) : null;
        if (data?.EffectiveDateType == IndexationEffectiveDateType.AnniversaryDate) {
            data.EffectiveDate = anniversarydate;
        }

        return (
            <>
                <div className="row">
                    <div className="col-sm-4 col-12">
                        <SelectEditor
                            options={[null, IndexationType.AverageWeeklyEarning, IndexationType.FixedPercentage]}
                            getText={(v) =>
                                v == null
                                    ? "No indexation (0% index)"
                                    : v == IndexationType.AverageWeeklyEarning
                                        ? "Average weekly earnings"
                                        : "User defined percentage"
                            }
                            selected={data?.IndexationType}
                            label="Indexation"
                            onChange={(v) => {
                                if (v == null) {
                                    this.props.onChange(null);
                                } else {
                                    if (data == null) {
                                        onChange({
                                            IndexationType: v,
                                            EffectiveDateType: IndexationEffectiveDateType.AnniversaryDate,
                                            EffectiveDate: anniversarydate
                                        });

                                    } else {
                                        data.IndexationType = v;
                                        if (v != IndexationType.FixedPercentage) {
                                            data.Percentage = null;
                                        }
                                        onChange(data);
                                    }
                                }
                            }}
                        />
                    </div>
                    {data?.IndexationType == IndexationType.FixedPercentage && (
                        <div className="col-sm-4 col-12">
                            <PercentageTextBoxEditor
                                value={data?.Percentage}
                                label={"Percentage"}
                                required={"Please enter percantage"}
                                maxNumberOfDecimalPlaces={{ errorMessage: "only allow two decimal places", value: 2 }}
                                moreThan={{ errorMessage: "percentage must be > 0 and <= 10", value: 0 }}
                                atMost={{ errorMessage: "percentage must be > 0 and <= 10", value: 10 }}
                                onChange={(v) => {
                                    data.Percentage = v;
                                    onChange(data);
                                }}
                            />
                        </div>
                    )}
                </div>
                {data?.IndexationType !== null && data?.IndexationType !== undefined && (
                    <div className="row">
                        <div className="col-sm-4 col-12">
                            <SelectEditor
                                options={[
                                    IndexationEffectiveDateType.AnniversaryDate,
                                    IndexationEffectiveDateType.FixedDate,
                                ]}
                                getText={(v) =>
                                    v == IndexationEffectiveDateType.AnniversaryDate
                                        ? "On anniversary date"
                                        : "On a user specified date"
                                }
                                onChange={(v) => {
                                    data.EffectiveDateType = v;
                                    if (v == IndexationEffectiveDateType.FixedDate) {
                                        if (data.IndexationType == IndexationType.AverageWeeklyEarning) {
                                            data.EffectiveDate = JsonDateParser.toJsonDate(addDays(addMonths(this.props.firstPaymentDate || new Date(), 3), 1));
                                        } else {
                                            data.EffectiveDate = JsonDateParser.toJsonDate(addDays(this.props.firstPaymentDate, 1));
                                        }
                                    }
                                    onChange(data);
                                }}
                                selected={data?.EffectiveDateType}
                                label={"Recalculation date"}
                                required="Please selected recalculation date type"
                            />
                        </div>
                        {data?.EffectiveDateType == IndexationEffectiveDateType.FixedDate && (
                            <div className="col-sm-4 col-12">
                                <DatePicker
                                    selected={JsonDateParser.toDateNoOffset(data.EffectiveDate)}
                                    label="First automatic increase date"
                                    {...datePickerOptions}
                                    alwaysValidateOnUpdate={false}
                                    filterDate={{
                                        errorMessage: "Date must also be between 1-28 of any month",
                                        validator: (v) => {
                                            if (v.getDate() > 28) { return false; }
                                            return true;
                                        },
                                    }}
                                    moreThan={{
                                        value: data.IndexationType == IndexationType.AverageWeeklyEarning ? addMonths(this.props.firstPaymentDate || new Date(), 3) : addDays(this.props.firstPaymentDate, 1),
                                        errorMessage: "The user specific renewal date selected must not be within 3 months of the start date of the payments",
                                    }}
                                    required="Please enter first automatic increase date"
                                    onChange={(v) => {
                                        data.EffectiveDate = JsonDateParser.toJsonDateNoOffset(v);
                                        onChange(data);
                                    }}
                                />
                            </div>
                        )}
                    </div>
                )}
            </>
        );
    }
}
